'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _react = require('react');

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _bananaI18n = require('banana-i18n');

var _bananaI18n2 = _interopRequireDefault(_bananaI18n);

var _bananaContext = require('./banana-context');

var _bananaContext2 = _interopRequireDefault(_bananaContext);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IntlProvider = function IntlProvider(_ref) {
	var locale = _ref.locale,
	    messages = _ref.messages,
	    children = _ref.children;

	// Convert to lowercase.
	// @see https://github.com/wikimedia/jquery.i18n/issues/120
	var banana = new _bananaI18n2.default(locale.toLowerCase(), {
		messages: messages
	});

	return (0, _react.createElement)(_bananaContext2.default.Provider, {
		value: banana
	}, children);
};

IntlProvider.propTypes = {
	children: _propTypes2.default.node.isRequired,
	locale: _propTypes2.default.string.isRequired,
	messages: _propTypes2.default.object.isRequired // eslint-disable-line react/forbid-prop-types
};

exports.default = IntlProvider;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@wikimedia/react.i18n/dist/intl-provider.js
// module id = 499
// module chunks = 0